<template>
  <AuthVisualShell :character-src="characterSrc" character-alt="Personagem Zinnes">
    <div v-if="!emailEnviado" class="login-content forgot-password-content">
      <div class="forgot-password-icon" aria-hidden="true">
        <v-icon large color="#FFF">mdi-key</v-icon>
      </div>

      <h2>Esqueceu sua senha?</h2>
      <p>Não se preocupe, enviaremos instruções de redefinição de senha para o seu email.</p>

      <v-form @submit.prevent="submitForm">
        <v-text-field
          v-model="email"
          label="Digite seu email..."
          required
          :error-messages="erro"
        ></v-text-field>

        <v-btn type="submit" :loading="loading" :disabled="loading" color="orange" class="btn-login">
          Enviar
        </v-btn>
      </v-form>

      <button type="button" class="forgot-password-back" @click="goToLogin">
        <v-icon small color="orange">mdi-arrow-left</v-icon>
        <span>Fazer login</span>
      </button>
    </div>

    <div v-else class="login-content forgot-password-content forgot-password-success">
      <div class="forgot-password-icon forgot-password-icon--success" aria-hidden="true">
        <v-icon large color="#FFF">mdi-email-check-outline</v-icon>
      </div>

      <h2>Verifique seu Email</h2>
      <p>Enviamos um link de redefinição de senha para <span class="email-highlight">{{ email }}</span></p>

      <button type="button" class="forgot-password-back" @click="goToLogin">
        <v-icon small color="orange">mdi-arrow-left</v-icon>
        <span>Fazer login</span>
      </button>
    </div>
  </AuthVisualShell>
</template>

<script>
import AuthVisualShell from '@/components/AuthVisualShell.vue';
import { PasswordServer } from '@/server/PasswordServer';

export default {
  components: {
    AuthVisualShell,
  },
  data() {
    return {
      email: '',
      emailEnviado: false,
      erro: '',
      service: new PasswordServer(),
      loading: false,
      characterSrc: require('@/assets/images/Miry.png'),
    };
  },
  methods: {
    async submitForm() {
      if (this.loading) return;

      if (!this.email) {
        this.erro = 'Informe seu e-mail.';
        return;
      }

      this.loading = true;
      this.erro = '';

      try {
        await this.service.forgot({ email: this.email });
        this.emailEnviado = true;
      } catch (error) {
        this.erro = this.forgotErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
    forgotErrorMessage(error) {
      if (!error?.response) {
        return 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.';
      }

      if (error?.response?.status === 400) {
        return 'Não foi possível enviar o link para este e-mail. Confira o endereço informado.';
      }

      if (error?.response?.status === 422) {
        return 'Informe um endereço de e-mail válido.';
      }

      if (error?.response?.status === 429) {
        return 'Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.';
      }

      if (error?.response?.status >= 500) {
        return 'Serviço temporariamente indisponível. Tente novamente mais tarde.';
      }

      return 'Não foi possível enviar o e-mail de recuperação.';
    },
    goToLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.forgot-password-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.forgot-password-content form {
  width: 100%;
}

.forgot-password-icon {
  display: inline-flex;
  width: 80px;
  height: 80px;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border-radius: 50%;
  background: var(--zinnes-primary);
  box-shadow:
    0 0 0 8px rgba(69, 23, 85, 0.08),
    0 12px 26px rgba(69, 23, 85, 0.22);
}

.forgot-password-icon--success {
  background: #1f9d55;
  box-shadow:
    0 0 0 8px rgba(31, 157, 85, 0.1),
    0 12px 26px rgba(31, 157, 85, 0.2);
}

.email-highlight {
  color: orange;
  font-weight: bold;
  overflow-wrap: anywhere;
}

.forgot-password-back {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: orange;
  cursor: pointer;
  font-weight: 700;
  transition-property: transform, opacity;
  transition-duration: 150ms;
  transition-timing-function: ease-out;
}

.forgot-password-back:active {
  transform: scale(0.96);
}

.forgot-password-back:hover {
  opacity: 0.82;
}

.forgot-password-success p {
  margin-bottom: 16px;
}
</style>
